import type { StoreOption, StoreSettings } from "../lib/api";
import { normalizeExternalLink } from "../lib/telegramLinks";
import type { ReactNode } from "react";

type HeaderProps = {
  store: StoreSettings | StoreOption;
  stores: StoreOption[];
  selectedStoreId: string;
  onStoreChange: (storeId: string) => void;
};

export function Header({ store, stores, selectedStoreId, onStoreChange }: HeaderProps) {
  return (
    <header className="profile-header">
      <img className="profile-avatar" src={store.avatarUrl ?? "/icons/icon.svg"} alt="" decoding="async" />
      <div className="profile-copy">
        <div className="profile-title-row">
          <h1>{store.name}</h1>
        </div>
        <p>{linkifyStoreDescription(store.description)}</p>
        {stores.length > 1 ? (
          <label className="store-switcher">
            <span>Канал:</span>
            <select value={selectedStoreId} onChange={(event) => onStoreChange(event.target.value)}>
              {stores.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </label>
        ) : null}
      </div>
    </header>
  );
}

function linkifyStoreDescription(text: string) {
  const pattern =
    /(https?:\/\/[^\s<]+|(?:www\.)?(?:t\.me|telegram\.me|vk\.com|vk\.ru|instagram\.com)\/[A-Za-z0-9._~:/?#[\]@!$&'()*+,;=%-]+|@([A-Za-z0-9_]{5,32})\b)/gi;
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text))) {
    const rawValue = match[0];
    const suffix = rawValue.match(/[.,;:!?)]*$/)?.[0] ?? "";
    const value = suffix ? rawValue.slice(0, -suffix.length) : rawValue;
    if (!value) continue;

    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
    nodes.push(
      <a href={normalizeExternalLink(value, match[2])} target="_blank" rel="noreferrer" key={`${value}-${match.index}`}>
        {value}
      </a>
    );
    if (suffix) nodes.push(suffix);
    lastIndex = match.index + rawValue.length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return nodes.length > 0 ? nodes : text;
}
